/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContratAvenantGridDto
 */
export interface ContratAvenantGridDto {
    /**
     * 
     * @type {number}
     * @memberof ContratAvenantGridDto
     */
    idavenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContratAvenantGridDto
     */
    types?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAvenantGridDto
     */
    numero?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContratAvenantGridDto
     */
    datePriseEnCours?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ContratAvenantGridDto
     */
    dateSignature?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAvenantGridDto
     */
    lieuSignature?: string | null;
}

/**
 * Check if a given object implements the ContratAvenantGridDto interface.
 */
export function instanceOfContratAvenantGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratAvenantGridDtoFromJSON(json: any): ContratAvenantGridDto {
    return ContratAvenantGridDtoFromJSONTyped(json, false);
}

export function ContratAvenantGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratAvenantGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idavenant': !exists(json, 'idavenant') ? undefined : json['idavenant'],
        'types': !exists(json, 'types') ? undefined : json['types'],
        'numero': !exists(json, 'numero') ? undefined : json['numero'],
        'datePriseEnCours': !exists(json, 'datePriseEnCours') ? undefined : (json['datePriseEnCours'] === null ? null : new Date(json['datePriseEnCours'])),
        'dateSignature': !exists(json, 'dateSignature') ? undefined : (json['dateSignature'] === null ? null : new Date(json['dateSignature'])),
        'lieuSignature': !exists(json, 'lieuSignature') ? undefined : json['lieuSignature'],
    };
}

export function ContratAvenantGridDtoToJSON(value?: ContratAvenantGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idavenant': value.idavenant,
        'types': value.types,
        'numero': value.numero,
        'datePriseEnCours': value.datePriseEnCours === undefined ? undefined : (value.datePriseEnCours === null ? null : value.datePriseEnCours.toISOString()),
        'dateSignature': value.dateSignature === undefined ? undefined : (value.dateSignature === null ? null : value.dateSignature.toISOString()),
        'lieuSignature': value.lieuSignature,
    };
}

